import { createContext } from 'react';
import { GtmUserCookieType } from 'types/GtmUserCookie';

export const userContext = createContext({
  retarg: undefined as string | undefined,
  cUserId: undefined as string | undefined,
  gtmUserCookie: undefined as GtmUserCookieType | undefined,
});
